<template>
  <nav>
    <div class="fill-height">
      <AlertMessages v-if="alertValue" :alert-type="alertType" :alert-msg="alertMsg" @reset="alertValue = false" />

      <!-- show draft tag -->
      <v-row v-if="!published && role == 'booster' && !loadingData && !mobile()" no-gutters
        class="text-right custom-draft-tag  custom-draft-tag-style-more-right">
        <v-col cols="12">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-chip data-testid="draft-available-chip" color="warning" text-color="black" v-on="on">
                {{ $t('draftSurveyAvailableTag') }}
              </v-chip>
            </template>
            <span>{{ $t('draftSurveyAvailableTooltip') }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <!-- end show draft tag -->

      <!-- no published items -->
      <v-row v-if="noPublishedItems == true && !loadingData && role != 'booster'" class="fill-height" align="center"
        data-testid="no-published-content">
        <v-col cols="12" :class="!mobile() ? 'px-3 mr-n2' : 'mr-n2'"
          :style="!mobile() ? 'padding-bottom: 83px; padding-top: 23px;' : ''" align="center">
          <EmptyPage :page-title="$t('noPublishedItemsTitle')" :page-text="$t('noPublishedItemsText')"
            page-image="image4" />
        </v-col>
      </v-row>

      <!-- locked content -->
      <v-row v-if="!loadingData && lockedContent && !noPublishedItems && role != 'booster'"
        class="greyactivitybackground fill-height" no-gutters>
        <v-col cols="12" :class="!mobile() ? 'px-3 mr-n2 fill-height' : 'mr-n2 fill-height'"
          :style="!mobile() ? 'padding-bottom: 83px; padding-top: 23px;' : ''">
          <LockedContent max-width="960px" elevation="0" class="fill-height" :content="requiredContent"
            :type="lockType" />
        </v-col>
      </v-row>

      <!--booster-->
      <v-row v-if="!loadingData && role == 'booster'" class="greyactivitybackground fill-height" no-gutters>
        <v-col cols="12" :class="!mobile() ? 'fill-height px-3 mr-n2' : 'fill-height mr-n2'"
          :style="!mobile() ? 'padding-bottom: 83px; padding-top: 23px' : ''">
          <div class="text-center d-none d-md-block">
            <ActivityViewToggle @toggleView="changeView" />
          </div>
          <!-- show empty page template -->
          <v-row class="greyactivitybackground fill-height" no-gutters>
            <v-col cols="12" :class="!mobile() ? 'px-3 mr-n2' : 'fill-height'">
              <v-tabs 
                v-model="tabs" 
                right 
                slider-color="white" 
                slider-size="0px"
                background-color="greyactivitybackground"
                active-class="tab-version-active"
                class="mx-auto fill-height view-survey" 
                data-testid="show-tabs" 
                :class="screen"
                :height="mobile() ? 0 : ''"
              >
                <v-tab 
                  href="#publish" 
                  v-if="published" 
                  v-show="!mobile()"
                  style="border-radius: 8px 8px 0 0" 
                  class="tab-version publish"
                >
                  {{ $t('published') }}
                </v-tab>

                <v-tab href="#draft" v-if="!published" v-show="!mobile()" style="color: #fbc02d;
                  border-radius: 8px 8px 0 0" class="tab-version draft">
                  {{ $t('draft') }}
                </v-tab>

                <v-tabs-items v-model="tabs" :class="!mobile() ? 'rounded-xxl survey-tabs' : 'fill-height'">
                  <v-tab-item :class="mobile() ? 'fill-height' : ''" :value="published ? 'publish' : 'draft'"
                    :key="published ? 'publish' : 'draft'" :transition="false" reverse-transition="false">
                    <EmptyPageActivity v-if="!surveys.length" max-width="960px" elevation="0"
                      class="mx-auto fill-height rounded-xxl" align="center" :page-title="$t('emptyActivitySurveyTitle')"
                      :style="`${published && !mobile() ? 'border:2px solid #F4F5F5;' : ''} ${!published && !mobile() ? 'border:2px solid #FBC02D;' : ''}`"
                      :page-text="$t('emptyActivitySurveyText')" page-image="image4"
                      :class="screen == 'mobile-view' ? 'mobile-view-simulator' : ''" />
                    <div class="fill-height" v-else>
                      <v-carousel v-model="model" :vertical="true" :show-arrows="false" hide-delimiters
                        :height="mobileOverride() ? '100%' : height" transition="scroll-y-transition"
                        reverse-transition="scroll-y-transition" class="survey-carousel" :class="!mobile() ? 'rounded-xxl' : ''" light
                        :style="`${published && !mobile() ? 'border:2px solid #F4F5F5;' : ''} ${!published && !mobile() ? 'border:2px solid #FBC02D;' : ''}`">
                        <v-carousel-item v-for="(selectedQuestion, i) in allQuestions" :key="i"
                          :style="`background-color:` + selectedQuestion.bg_color"
                          :class="screen == 'mobile-view' ? 'pb-16' : ''">
                          <v-container v-if="selectedQuestion.type == 'start'" data-testid="start-screen" ref="start"
                            class="list-group-item fill-height pa-0"
                            :class="{ 'mobile-view-simulator-survey': screen == 'mobile-view', 'white': mobile() }">
                            <v-row justify="center" align="center" no-gutters>
                              <v-col cols="12" :style="`background-color:` + selectedQuestion.bg_color">
                                <StartScreen :anonymous="isAnonymous" :title="startTitle" :description="startDescription"
                                  :imageDisplay="startImageDisplay" :image="startImage"
                                  :color="startColor == null ? '#FFFFFF' : startColor" />
                              </v-col>
                            </v-row>
                          </v-container>
                          <v-container v-if="selectedQuestion.type != 'start' && selectedQuestion.type != 'end'"
                            class="list-group-item fill-height pa-0"
                            :class="screen == 'mobile-view' ? 'mobile-view-simulator-survey' : ''">
                            <v-row justify="center" align="center" no-gutters>
                              <v-col cols="12">
                                <div class="content-block rounded-xxl" :class="{ 'pa-8 mobile' : mobileOverride(), 'pa-8 desktop': !mobileOverride(), 'mt-16': mobile() }"  :style="mobile() ? 'margin-bottom: 120px !important' : ''">
                                  <v-row align="center" no-gutters class="text-center">
                                    <v-col cols="12"
                                      v-if="selectedQuestion.question && strip(selectedQuestion.question).trim() != ''">
                                      <p class="text-h6 no-break" v-html="selectedQuestion.question"></p>
                                    </v-col>
                                    <v-col cols="12" class="mt-3"
                                      v-if="selectedQuestion.description && strip(selectedQuestion.description).trim() != ''">
                                      <p class="text-subtitle-2 font-weight-regular greytext--text no-break"
                                        v-html="selectedQuestion.description"></p>
                                    </v-col>
                                  </v-row>
                                  <v-row v-if="selectedQuestion.type == 1" align="center" justify="center"
                                    data-testid="survey-1" class="mt-5" no-gutters>
                                    <v-col cols="12" sm="7">
                                      <MultipleChoiceTextQuestionTextAnswer :question="selectedQuestion" />
                                    </v-col>
                                  </v-row>
                                  <v-row v-if="selectedQuestion.type == 2" align="center" justify="center"
                                    data-testid="survey-2" class="mt-5" no-gutters>
                                    <v-col cols="12">
                                      <MultipleChoiceTextQuestionTextImageAnswer :question="selectedQuestion" />
                                    </v-col>
                                  </v-row>
                                  <v-row v-if="selectedQuestion.type == 3" align="center" justify="center"
                                    data-testid="survey-2" class="mt-5" no-gutters>
                                    <v-col cols="12" sm="7">
                                      <MultipleChoiceTextImageQuestionTextAnswer :question="selectedQuestion" />
                                    </v-col>
                                  </v-row>
                                  <v-row v-else-if="selectedQuestion.type == 4" align="center" justify="center"
                                    data-testid="survey-4" class="mt-5" no-gutters>
                                    <v-col cols="12" sm="7">
                                      <OpenText :question="selectedQuestion" />
                                    </v-col>
                                  </v-row>
                                  <v-row v-else-if="selectedQuestion.type == 5" align="center" justify="center"
                                    data-testid="survey-5" class="mt-5" no-gutters>
                                    <v-col cols="12" sm="7">
                                      <OpenTextAttachment :question="selectedQuestion" />
                                    </v-col>
                                  </v-row>
                                  <v-row v-else-if="selectedQuestion.type == 6" align="center" justify="center"
                                    data-testid="survey-6" class="mt-5" no-gutters>
                                    <v-col cols="12">
                                      <RatingStars :question="selectedQuestion" />
                                    </v-col>
                                  </v-row>
                                  <v-row v-else-if="selectedQuestion.type == 7" align="center" justify="center"
                                    data-testid="survey-7" class="mt-5" no-gutters>
                                    <v-col cols="12">
                                      <RatingNumbers :question="selectedQuestion" />
                                    </v-col>
                                  </v-row>
                                  <v-row v-else-if="selectedQuestion.type == 8" align="center" justify="center"
                                    data-testid="survey-8" class="mt-5" no-gutters>
                                    <v-col cols="12">
                                      <RatingNumbersComment :question="selectedQuestion" :screen="screen"/>
                                    </v-col>
                                  </v-row>
                                </div>
                              </v-col>
                            </v-row>
                          </v-container>
                          <v-container v-if="selectedQuestion.type == 'end'" data-testid="end-screen" ref="end"
                            class="list-group-item fill-height pa-0"
                            :class="screen == 'mobile-view' ? 'mobile-view-simulator-survey' : ''">
                            <v-row justify="center" align="center" no-gutters>
                              <v-col cols="12" :style="`background-color:` + selectedQuestion.bg_color">
                                <EndScreen :anonymous="isAnonymous" :title="endTitle" :description="endDescription"
                                  :imageDisplay="endImageDisplay" :image="endImage"
                                  :color="endColor == null ? '#FFFFFF' : endColor"/>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-carousel-item>
                        <v-footer v-if="surveys.length > 0 && screen == 'mobile-view'" class="white pa-0 mt-n16">
                          <v-col fixed align="center" class="pa-0 border-top-simulator-footer">
                            <v-btn v-if="model != '0'" data-testid="previous-button" outlined elevation="0"
                              class="rounded-xxl text-none mx-4 px-4 my-4" @click="questionIndex--, model--">
                              {{ $t('previous') }}
                            </v-btn>

                            <v-btn v-if="model != surveys.length + 1" data-testid="next-button" color="darktext"
                              class="rounded-xxl text-none white--text px-4 my-4 mx-4" @click="questionIndex++, model++">
                              {{ $t('next') }}
                            </v-btn>
                          </v-col>
                        </v-footer>
                      </v-carousel>
                    </div>
                    <v-row v-if="surveys.length > 0 && screen != 'mobile-view'" class="survey-carousel-navigation"
                      :class="mobile() ? 'v-footer--fixed white' : ''"
                      :style="mobile() ? 'bottom: 0px; left: 0px; right: 0px' : ''">
                      <v-col fixed align="center">
                        <v-btn v-if="model != '0'" data-testid="previous-button" outlined elevation="0"
                          class="rounded-xxl text-none mx-4 px-4 my-4" @click="questionIndex--, model--">
                          {{ $t('previous') }}
                        </v-btn>

                        <v-btn v-if="model != surveys.length + 1" data-testid="next-button" color="darktext"
                          class="rounded-xxl text-none white--text px-4 my-4 mx-4" @click="questionIndex++, model++">
                          {{ $t('next') }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>
              </v-tabs>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!--end booster-->

      <!--participant-->
      <v-row v-if="!loadingData && role != 'booster' && !lockedContent && !noPublishedItems"
        class="greyactivitybackground fill-height" no-gutters>
        <v-col cols="12" class="fill-height mr-n2" :class="!mobile() ? 'px-3' : ''"
          :style="!mobile() ? 'padding-bottom: 83px; padding-top: 23px' : ''">
          <v-row class="greyactivitybackground fill-height" no-gutters>
            <v-col cols="12" :class="!mobile() ? 'px-3 mr-n2' : 'fill-height'">
              <div class="view-survey desktop-view mx-auto" :class="mobile() ? 'fill-height' : ''">
                <v-carousel v-model="model" :vertical="true" :show-arrows="false" hide-delimiters
                  :height="mobileOverride() ? '100%' : height" transition="scroll-y-transition"
                  reverse-transition="scroll-y-transition" class="survey-carousel" :class="!mobile() ? 'rounded-xxl' : ''"
                  light
                  :style="`${published && !mobile() ? 'border:2px solid #F4F5F5;' : ''} ${!published && !mobile() ? 'border:2px solid #FBC02D;' : ''}`">
                  <v-carousel-item v-for="(selectedQuestion, i) in allQuestions" :key="i"
                    :style="`background-color:` + selectedQuestion.bg_color">
                    <v-container v-if="selectedQuestion.type == 'start'" data-testid="start-screen" ref="start"
                      class="list-group-item fill-height pa-0">
                      <v-row justify="center" align="center" no-gutters>
                        <v-col cols="12" :style="`background-color:` + selectedQuestion.bg_color">
                          <StartScreen :anonymous="isAnonymous" :title="startTitle" :description="startDescription"
                            :imageDisplay="startImageDisplay" :image="startImage"
                            :color="startColor == null ? '#FFFFFF' : startColor" :role="role" :started="started"
                            @startSurvey="startSurvey"/>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-container v-if="selectedQuestion.type != 'start' && selectedQuestion.type != 'end'"
                      class="list-group-item fill-height pa-0">
                      <v-row justify="center" align="center" no-gutters>
                        <v-col cols="12">
                          <div class="content-block rounded-xxl" :class="{ 'pa-8 mobile': mobileOverride(), 'pa-8 desktop' : !mobileOverride(), 'mt-16': mobile() }"  :style="mobile() ? 'margin-bottom: 120px !important' : ''">
                            <v-row align="center" no-gutters class="text-center">
                              <v-col cols="12"
                                v-if="selectedQuestion.question && strip(selectedQuestion.question).trim() != ''">
                                <p class="text-h6 no-break" v-html="selectedQuestion.question"></p>
                                <!-- {{ selectedQuestion.id }} -->
                              </v-col>
                              <v-col cols="12" class="mt-3"
                                v-if="selectedQuestion.description && strip(selectedQuestion.description).trim() != ''">
                                <p class="text-subtitle-2 font-weight-regular greytext--text no-break"
                                  v-html="selectedQuestion.description"></p>
                              </v-col>
                            </v-row>
                            <v-row v-if="selectedQuestion.type == 1" align="center" justify="center"
                              data-testid="survey-1" class="mt-5" no-gutters>
                              <v-col cols="12" sm="7">
                                <MultipleChoiceTextQuestionTextAnswer :question="selectedQuestion" :role="role"
                                  :invalidAnswers="invalidAnswers" :hasSubmittedSurvey="hasSubmittedSurvey"
                                  @sendAnswer="addAnswer" />
                              </v-col>
                            </v-row>
                            <v-row v-if="selectedQuestion.type == 2" align="center" justify="center"
                              data-testid="survey-2" class="mt-5" no-gutters>
                              <v-col cols="12">
                                <MultipleChoiceTextQuestionTextImageAnswer :question="selectedQuestion" :role="role"
                                  :invalidAnswers="invalidAnswers" :hasSubmittedSurvey="hasSubmittedSurvey"
                                  @sendAnswer="addAnswer" />
                              </v-col>
                            </v-row>
                            <v-row v-if="selectedQuestion.type == 3" align="center" justify="center"
                              data-testid="survey-2" class="mt-5" no-gutters>
                              <v-col cols="12" sm="7">
                                <MultipleChoiceTextImageQuestionTextAnswer :question="selectedQuestion" :role="role"
                                  :invalidAnswers="invalidAnswers" :hasSubmittedSurvey="hasSubmittedSurvey"
                                  @sendAnswer="addAnswer" />
                              </v-col>
                            </v-row>
                            <v-row v-else-if="selectedQuestion.type == 4" align="center" justify="center"
                              data-testid="survey-4" class="mt-5" no-gutters>
                              <v-col cols="12" sm="7">
                                <OpenText :question="selectedQuestion" :role="role" :invalidAnswers="invalidAnswers"
                                  :hasSubmittedSurvey="hasSubmittedSurvey" @sendAnswer="addAnswer" />
                              </v-col>
                            </v-row>
                            <v-row v-else-if="selectedQuestion.type == 5" align="center" justify="center"
                              data-testid="survey-5" class="mt-5" no-gutters>
                              <v-col cols="12" sm="7">
                                <OpenTextAttachment :question="selectedQuestion" :role="role"
                                  :invalidAnswers="invalidAnswers" :hasSubmittedSurvey="hasSubmittedSurvey"
                                  @sendAnswer="addAnswer" />
                              </v-col>
                            </v-row>
                            <v-row v-else-if="selectedQuestion.type == 6" align="center" justify="center"
                              data-testid="survey-6" class="mt-5" no-gutters>
                              <v-col cols="12">
                                <RatingStars :question="selectedQuestion" :role="role" :invalidAnswers="invalidAnswers"
                                  :hasSubmittedSurvey="hasSubmittedSurvey" @sendAnswer="addAnswer" />
                              </v-col>
                            </v-row>
                            <v-row v-else-if="selectedQuestion.type == 7" align="center" justify="center"
                              data-testid="survey-7" class="mt-5" no-gutters>
                              <v-col cols="12">
                                <RatingNumbers :question="selectedQuestion" :role="role" :invalidAnswers="invalidAnswers"
                                  :hasSubmittedSurvey="hasSubmittedSurvey" @sendAnswer="addAnswer" />
                              </v-col>
                            </v-row>
                            <v-row v-else-if="selectedQuestion.type == 8" align="center" justify="center"
                              data-testid="survey-8" class="mt-5" no-gutters>
                              <v-col cols="12">
                                <RatingNumbersComment :question="selectedQuestion" :role="role"
                                  :invalidAnswers="invalidAnswers" :hasSubmittedSurvey="hasSubmittedSurvey"
                                  @sendAnswer="addAnswer" />
                              </v-col>
                            </v-row>
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-container v-if="selectedQuestion.type == 'end'" data-testid="end-screen" ref="end"
                      class="list-group-item fill-height pa-0">
                      <v-row justify="center" align="center" no-gutters>
                        <v-col cols="12" :style="`background-color:` + selectedQuestion.bg_color">
                          <EndScreen :anonymous="isAnonymous" :title="endTitle" :description="endDescription"
                            :imageDisplay="endImageDisplay" :image="endImage" :nameUser="name"
                            :color="endColor == null ? '#FFFFFF' : endColor" :role="role" :answers="allAnswers"
                            @submitSurvey="submitSurvey" :invalidAnswers="invalidAnswers"
                            :confirmationMsg="confirmationMessage"
                            @redirectToUnasweredQuestion="redirectToUnasweredQuestion"/>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-carousel-item>
                </v-carousel>
              </div>
              <v-row v-if="surveys.length > 0 && !confirmationMessage && started" class="survey-carousel-navigation"
                :class="mobile() ? 'v-footer--fixed white' : ''"
                :style="mobile() ? 'bottom: 0px; left: 0px; right: 0px' : ''">
                <v-col fixed align="center">
                  <v-btn v-if="model != '0'" data-testid="previous-button" outlined elevation="0"
                    class="rounded-xxl text-none mx-4 px-4 my-4" @click="prev()">
                    {{ $t('previous') }}
                  </v-btn>
                  <v-btn v-if="model != surveys.length + 1 && (model != 0 || (model == 0 && started))"
                    data-testid="next-button" color="darktext" class="rounded-xxl text-none white--text px-4 my-4 mx-4"
                    @click="next()">
                    {{ $t('next') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!--end participant-->
      <v-card ref="viewNavigationButtons" max-width="960px" elevation="0" class="mx-auto"
        v-if="role != 'booster' && !loadingData && showActivityNavigation">
        <NavigationBackButton :activity-pages="activity_pages" />
        <NavigationNextButton :activity-pages="activity_pages" />
      </v-card>

      <EditButtonWithLinkInActivity v-if="isAuth && role == 'booster' && !loadingData && !mobile()"
        data-testid="edit-activity-survey-button" rounded="xxl" :class="editButtonTextColor" :color="editButtonColor"
        :link="{ title: '', route: '/activity/' + $route.params.id + '/survey/' + $route.params.surveyId + '/edit' }"
        :classes="'edit-activity'" @openPreventEditingDialog="dialogVisible = true" />

      <ConfirmationDialog v-if="dialogVisible" ref="confirmationDialog" :visible="dialogVisible"
        :cd-title="confirmationDialogTitle" :cd-text="confirmationDialogText" :cd-submit-btn="confirmationDialogSubmitBtn"
        :cd-cancel-btn="confirmationDialogCancelBtn" :cd-submit-btn-color="cdSubmitBtnColor"
        data-testid="confirmation-dialog" @close="dialogVisible = false" @proceedSubmit="dialogVisible = false" />

      <ConfirmationDialog v-if="dialogVisibleNavigateAway" ref="confirmationDialog" :visible="dialogVisibleNavigateAway"
        :cd-title="confirmationDialogTitleNavigateAway" :cd-text="confirmationDialogTextNavigateAway"
        :cd-submit-btn="confirmationDialogSubmitBtnNavigateAway" :cd-cancel-btn="confirmationDialogCancelBtnNavigateAway"
        :cd-submit-btn-color="cdSubmitBtnColor" data-testid="confirmation-dialog-navigate-away"
        @close="dialogVisibleNavigateAway = false" @proceedSubmit="navigateAway()" />
    </div>
  </nav>
</template>

<script>
import i18n from '../../plugins/i18n'
import AlertMessages from '../../components/AlertMessages'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import { eventBus } from '../../eventbus'
import moment from 'moment'
import { getActivity, getActivityPages, getActivitySurvey, getSurveyQuestions, getImageURLsInActivitySurvey, submitSurvey, startAttemptInSurvey } from '../../api/activityApi'
import EmptyPage from '../../components/EmptyPage'
import EmptyPageActivity from '../../components/EmptyPageActivity'
import EditButtonWithLinkInActivity from '../../components/EditButtonWithLinkInActivity'
import ConfirmationDialog from '../../components/ConfirmationDialog'
import ActivityViewToggle from '../../components/ActivityViewToggle'
import MultipleChoiceTextQuestionTextAnswer from '../../components/editor_components/survey/view/MultipleChoiceTextQuestionTextAnswer.vue'
import MultipleChoiceTextQuestionTextImageAnswer from '../../components/editor_components/survey/view/MultipleChoiceTextQuestionTextImageAnswer.vue'
import MultipleChoiceTextImageQuestionTextAnswer from '../../components/editor_components/survey/view/MultipleChoiceTextImageQuestionTextAnswer.vue'
import OpenText from '../../components/editor_components/survey/view/OpenText.vue'
import OpenTextAttachment from '../../components/editor_components/survey/view/OpenTextAttachment.vue'
import RatingNumbers from '../../components/editor_components/survey/view/RatingNumbers.vue'
import RatingNumbersComment from '../../components/editor_components/survey/view/RatingNumbersComment.vue'
import RatingStars from '../../components/editor_components/survey/view/RatingStars.vue'
import StartScreen from '../../components/editor_components/survey/view/StartScreen'
import EndScreen from '../../components/editor_components/survey/view/EndScreen.vue';
import NavigationNextButton from '../../components/NavigationNextButton'
import NavigationBackButton from '../../components/NavigationBackButton'
import LockedContent from '../../components/LockedContent'

export default {
  components: {
    EmptyPage,
    EmptyPageActivity,
    EditButtonWithLinkInActivity,
    AlertMessages,
    ConfirmationDialog,
    ActivityViewToggle,
    MultipleChoiceTextQuestionTextAnswer,
    MultipleChoiceTextQuestionTextImageAnswer,
    MultipleChoiceTextImageQuestionTextAnswer,
    OpenText,
    OpenTextAttachment,
    RatingNumbers,
    RatingNumbersComment,
    RatingStars,
    StartScreen,
    EndScreen,
    NavigationNextButton,
    NavigationBackButton,
    LockedContent
  },
  mixins: [repeatedMethodsMixin],
  data() {
    return {
      isAuth: window.$cookies.get("token") ? true : false,
      loadingData: false,
      spaceId: window.$cookies.get('space_id'),
      activityId: this.$route.params.id,
      pageId: this.$route.params.pageId,
      quizId: this.$route.params.quizId,
      scormId: this.$route.params.scormId,
      surveyId: this.$route.params.surveyId,
      alertMsg: '',
      alertValue: false,
      alertType: '',
      activity_pages: [],
      role: '',
      hasActivityAccess: false,
      published: false,
      editButtonColor: 'warning',
      editButtonTextColor: 'black--text',
      noPublishedItems: false,
      lockedContent: false,
      requiredContent: {},
      pageExist: true,
      dialogVisible: false,
      confirmationDialogTitle: i18n.t('confirmationDialogTitlePreventEdit'),
      confirmationDialogText: i18n.t('confirmationDialogTextPreventEdit'),
      confirmationDialogSubmitBtn: i18n.t('ok'),
      confirmationDialogCancelBtn: i18n.t('cancel'),
      cdSubmitBtnColor: 'accent',
      draftVersion: false,
      lockType: null,
      checkboxCertificate: false,
      tabs: 'publish',
      screen: 'desktop-view',
      surveys: [],
      isAnonymous: false,
      startTitle: null,
      startDescription: null,
      endTitle: null,
      endDescription: null,
      startImage: null,
      startImageDisplay: null,
      endImage: null,
      endImageDisplay: null,
      startColor: null,
      endColor: null,
      questionIndex: -1,
      selectedQuestion: { qid: '', type: '', bg_color: this.startColor },
      model: 0,
      allQuestions: [],
      allAnswers: [],
      lastAnswer: {},
      name: '',
      invalidAnswers: [],
      hasSubmittedSurvey: false,
      confirmationMessage: false,
      dialogVisibleNavigateAway: false,
      confirmationDialogTitleNavigateAway: i18n.t('confirmationDialogTitleNavigateAway'),
      confirmationDialogTextNavigateAway: i18n.t('confirmationDialogTextNavigateAway'),
      confirmationDialogSubmitBtnNavigateAway: i18n.t('leave'),
      confirmationDialogCancelBtnNavigateAway: i18n.t('back'),
      started: false,
      navigateAwayPath: null,
      preventRedirect: true,
      showActivityNavigation: true
    }
  },

  async beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getPrevRoute(from);
    })
  },

  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav)
  },

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.preventNav);
  },

  beforeRouteLeave(to, from, next) {
    if (this.started && this.role != 'booster' && this.preventRedirect) {
      this.navigateAwayPath = to
      this.dialogVisibleNavigateAway = true
      next(false)
    } else {
      next()
    }
  },

  beforeRouteUpdate(to, from, next) {
    if (this.started && this.role != 'booster' && this.preventRedirect) {
      this.navigateAwayPath = to
      this.dialogVisibleNavigateAway = true
      next(false)
    } else {
      next()
    }
  },

  watch: {
    questionIndex(val) {
      if (val == this.surveys.length) {
        this.selectedQuestion = { qid: 'end', type: 'end', bg_color: this.endColor }
      } else if (val == -1) {
        this.selectedQuestion = { qid: 'start', type: 'start', bg_color: this.startColor }
      } else {
        this.selectedQuestion = this.surveys[val]
      }
    }
  },
  computed: {
    height() {
      if (this.$vuetify.breakpoint.name == 'sm') {
        return 400
      }
      if (this.$vuetify.breakpoint.name == 'md') {
        return 400
      }
      if (this.$vuetify.breakpoint.name == 'lg') {
        return 640
      }
      if (this.$vuetify.breakpoint.name == 'xl') {
        return 640
      }
      return 640
    }
  },

  async created() {
    if (this.$route.params.successfullyCreatedActivity) {
      this.alertMsg = i18n.t('createActivitySuccess');
      this.alertType = 'success'
      this.alertValue = true
    }

    if (this.$route.params.successfullyCreatedActivityPage) {
      this.alertMsg = i18n.t('createActivityPageSuccess');
      this.alertType = 'success'
      this.alertValue = true
    }

    if (this.$route.params.successfullyCreatedActivityQuiz) {
      this.alertMsg = i18n.t('createActivityQuizSuccess');
      this.alertType = 'success'
      this.alertValue = true
    }

    if (this.$route.params.successfullyAddedActivityScorm) {
      this.alertMsg = i18n.t('createActivityScormSuccess');
      this.alertType = 'success'
      this.alertValue = true
    }

    if (this.$route.params.successfullyCreatedActivityChecklist) {
      this.alertMsg = i18n.t('createActivityChecklistSuccess');
      this.alertType = 'success'
      this.alertValue = true
    }

    if (this.$route.params.successfullyCreatedActivitySurvey) {
      this.alertMsg = i18n.t('createActivitySurveySuccess');
      this.alertType = 'success'
      this.alertValue = true
    }

    if (this.$route.params.successfullyPublishedActivitySurvey) {
      this.alertMsg = i18n.t('publishActivitySurveySuccess')
      this.alertType = 'success'
      this.alertValue = true
    }
    if (this.$route.params.successfullyUpdatedUnpublishedActivitySurvey) {
      this.alertMsg = i18n.t('editSurveyDraftSuccess')
      this.alertType = 'success'
      this.alertValue = true
    }
    if (this.$route.params.successfullyUpdatedPublishedActivitySurvey) {
      this.alertMsg = i18n.t('editSurveySuccess')
      this.alertType = 'success'
      this.alertValue = true
    }

    if (this.$route.params.successfullySharedActivity) {
      this.alertMsg = i18n.t('shareActivitySuccess')
      this.alertType = 'success'
      this.alertValue = true
    }

    if (this.$route.params.successfullyDeletedActivityPage) {
      this.alertMsg = i18n.t('deleteActivityPageSuccess')
      this.alertType = 'success'
      this.alertValue = true
    }

    if (this.$route.params.successfullyDeletedActivityQuiz) {
      this.alertMsg = i18n.t('deleteActivityQuizSuccess')
      this.alertType = 'success'
      this.alertValue = true
    }
    if (this.$route.params.successfullyDeletedActivityScorm) {
      this.alertMsg = i18n.t('deleteActivityScormSuccess')
      this.alertType = 'success'
      this.alertValue = true
    }
    if (this.$route.params.successfullyDeletedActivityChecklist) {
      this.alertMsg = i18n.t('deleteActivityChecklistSuccess')
      this.alertType = 'success'
      this.alertValue = true
    }
    if (this.$route.params.successfullyDeletedActivitySurvey) {
      this.alertMsg = i18n.t('deleteActivitySurveySuccess')
      this.alertType = 'success'
      this.alertValue = true
    }

    if (this.$route.params.successfullyDuplicatedActivity) {
      this.alertValue = true
      this.alertType = 'success'
      this.alertMsg = i18n.t('duplicateActivitySuccess')
    }
    if (this.$route.params.boostersAddedInActivity) {
      this.alertMsg = i18n.t('addActivityBoostersSuccess')
      this.alertType = 'success'
      this.alertValue = true
    }

    if (this.$route.params.successfullyConnectedActivityEduAdmin) {
      this.alertMsg = i18n.t("eduAdminConnectedActivitySuccess");
      this.alertType = "success";
      this.alertValue = true;
    }

    if (this.$route.params.preventEditing) {
      this.dialogVisible = true
    }

    this.loadingData = true
    this.lockedContent = false
    this.surveyId = this.$route.params.surveyId

    await this.getActivityPages()

    await this.getActivity()

    if (this.role == 'booster') {
      await this.getSurveyQuestions()
    } else {
      if (!this.lockedContent && !this.noPublishedItems) {
        await this.getSurveyQuestions()
      }
    }

    if (this.role == 'participant' || this.role == 'guest') {
      //reset navigation
      eventBus.$emit('changeNavigationInActivity', this.activity_pages)
    }


    this.loadingData = false
  },

  methods: {
    mobileOverride() {
      if (this.screen == 'mobile-view') {
        return true;
      } else {
        return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm);
      }
    },
    changeView(val) {
      this.screen = val
    },
    getPrevRoute(data) {
      if (data.name == 'Activitites' || data.name == 'ViewHub' || data.name == 'ViewCategory' || data.name == 'SharedWithMe' || data.name == 'Dashboard' || data.name == 'AllActivitiesParticipant' || data.name == 'AllHubsParticipant' || data.name == 'ActivitiesParticipant') {
        eventBus.$emit('setActivityExitBtn', data)
      }
    },

    async getActivity() {
      try {
        const response = await getActivity(this.activityId)

        if (response.status == 200) {
          this.role = response.data.data.attributes.role
          if (response.data.data.attributes.activity_page_id == null) {
            this.noPublishedItems = true
          } else {
            if (!this.pageExist) {
              this.$router.push({ name: 'PageNotFound' })
            } else if (this.role != 'booster' && !this.published) {
              this.$router.push({ name: 'PageAccessDenied' })
            } else if (this.role == 'booster' || (this.role != 'booster' && !this.lockedContent)) {
              const response_page = await getActivitySurvey(this.surveyId)
              if (response_page.status == 200) {
                this.published = response_page.data.data.attributes.published
                this.editButtonColor = this.published ? "accent" : "warning"
                this.editButtonTextColor = this.published ? "white--text" : "black--text"
                this.checkboxCertificate = response.data.data.attributes.certificate_enabled
                this.isAnonymous = response_page.data.data.attributes.is_anonymous
                this.startTitle = response_page.data.data.attributes.start_title
                this.startDescription = response_page.data.data.attributes.start_description
                this.startImage = response_page.data.data.attributes.start_image
                this.startImageDisplay = response_page.data.data.attributes.start_image_url
                this.startColor = response_page.data.data.attributes.start_bg_color
                this.endTitle = response_page.data.data.attributes.end_title
                this.endDescription = response_page.data.data.attributes.end_description
                this.endImage = response_page.data.data.attributes.end_image
                this.endImageDisplay = response_page.data.data.attributes.end_image_url
                this.endColor = response_page.data.data.attributes.end_bg_color
              }
            }
          }
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 404) {
            if (this.isAuth) {
              this.$router.push({ name: 'PageNotFound' })
            } else {
              this.$router.push({ name: 'CustomLogin', query: { referer: this.$route.fullPath } })
            }
          } else if (e.response.status == 403) {
            this.$router.push({ name: 'PageAccessDenied' })
          } else if(e.response.status != 401) {
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          }
        }
      }
    },
    async getActivityPages() {
      try {
        const response = await getActivityPages(this.activityId)
        if (response.status == 200) {
          if (!response.data.data.find(page => page.attributes.entity_id == this.surveyId && page.attributes.entity_type == 'survey')) {
            this.pageExist = false
          }
          this.activity_pages = response.data.data.filter(page => page.attributes.is_published == true)
          if (this.activity_pages.find(page => page.attributes.entity_id == this.surveyId && page.attributes.entity_type == 'survey')) {
            this.published = true
          }
          var requiredPageId = this.activity_pages.find(page => page.attributes.entity_id == this.surveyId && page.attributes.entity_type == 'survey').attributes.rule_item_id
          var requiredPageStatus = this.activity_pages.find(page => page.attributes.entity_id == this.surveyId && page.attributes.entity_type == 'survey').attributes.rule_fulfilled
          var requiredDate = this.activity_pages.find(page => page.attributes.entity_id == this.surveyId && page.attributes.entity_type == 'survey').attributes.rule_available_after

          if (requiredPageId != null && requiredPageStatus == false) {
            this.lockedContent = true
            this.requiredContent = this.activity_pages.find(page => page.id == requiredPageId)
            this.lockType = "feedItemDependent"
          } else if (requiredDate != null && requiredPageStatus == false) {
            this.lockedContent = true
            this.requiredContent = { date: moment(requiredDate).format('YYYY-MM-DD') + ' ' + moment(requiredDate).format('HH:mm') }
            this.lockType = "dateDependent"
          }
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true
          this.alertType = 'error'
          this.alertMsg = i18n.t('serverError')
        }
      }
    },
    async getSurveyQuestions() {
      try {
        const response = await getSurveyQuestions(this.surveyId)
        if (response) {
          if (response.status == 200) {
            for (const value of response.data.data) {
              if (value.attributes.type == 1 || value.attributes.type == 2 || value.attributes.type == 3) {
                var responseQuestionImageURL = await this.changeImageURLs(value.attributes.image)
                var options = []
                for (const answer of value.attributes.options) {
                  var responseAnswerImageURL = await this.changeImageURLs(answer.image)
                  options.push(
                    {
                      aid: answer.aid,
                      option: answer.option,
                      image: answer.image,
                      imageDisplay: responseAnswerImageURL,
                    }
                  )
                }

                this.surveys.push({
                  qid: value.id,
                  id: value.id,
                  question: value.attributes.question,
                  description: value.attributes.description,
                  image: value.attributes.image,
                  imageDisplay: responseQuestionImageURL,
                  bg_color: value.attributes.bg_color,
                  allowed_options: value.attributes.allowed_options,
                  type: value.attributes.type,
                  options: options
                });

              } else if (value.attributes.type == 4 || value.attributes.type == 5) {
                this.surveys.push({
                  qid: value.id,
                  id: value.id,
                  question: value.attributes.question,
                  description: value.attributes.description,
                  image: null,
                  imageDisplay: null,
                  bg_color: value.attributes.bg_color,
                  type: value.attributes.type,
                });

              } else {
                this.surveys.push({
                  qid: value.id,
                  id: value.id,
                  question: value.attributes.question,
                  description: value.attributes.description,
                  image: null,
                  imageDisplay: null,
                  bg_color: value.attributes.bg_color,
                  allowed_options: value.attributes.allowed_options,
                  type: value.attributes.type,
                });
              }

            }
            //created new array that will contains all question, start screen and endscreen. For carousel scroll effect
            this.allQuestions = JSON.parse(JSON.stringify(this.surveys))
            this.allQuestions.unshift({ qid: 'start', type: 'start', bg_color: this.startColor == null ? '#FFFFFF' : this.startColor })
            this.allQuestions.push({ qid: 'end', type: 'end', bg_color: this.endColor == null ? '#FFFFFF' : this.endColor })
          }
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true
          this.alertType = 'error'
          this.alertMsg = i18n.t('serverError')
        }
      }
    },

    async changeImageURLs(value) {
      var imagesToCheck = []
      if (value != null) {
        imagesToCheck = [value]

        let dataImage = {
          data: {
            type: "surveys",
            id: this.surveyId,
            attributes: {
              paths: imagesToCheck,
              space_id: this.spaceId
            }
          }
        };

        const responseImageQuestion = await getImageURLsInActivitySurvey(this.surveyId, dataImage)
        return responseImageQuestion.data.meta.files[value]
      } else {
        return null
      }

    },

    preventNav(event) {
      if (this.started && this.role != 'booster' && this.preventRedirect) {
        event.preventDefault()
        event.returnValue = ""
      }
    },

    async navigateAway() {
      this.dialogVisibleNavigateAway = false
      this.preventRedirect = false
      await this.$router.push(this.navigateAwayPath)
    },

    addAnswer(answer) {
      this.lastAnswer = answer
    },
    async prev() {
      //if answer was changed
      if (Object.keys(this.lastAnswer).length > 0) {
        //check if question was already submitted
        const indexOfObject = this.allAnswers.findIndex(object => {
          return object.id === this.lastAnswer.id;
        });
        //if found update
        if (indexOfObject != -1) {
          this.allAnswers[indexOfObject] = this.lastAnswer
        } else {
          //add new answer
          this.allAnswers.push(this.lastAnswer)
        }

        this.lastAnswer = {}
      }

      this.questionIndex--
      this.model--
    },
    async next() {
      //if answer was changed
      if (Object.keys(this.lastAnswer).length > 0) {
        //check if question was already submitted
        const indexOfObject = this.allAnswers.findIndex(object => {
          return object.id === this.lastAnswer.id;
        });
        //if found update
        if (indexOfObject != -1) {
          this.allAnswers[indexOfObject] = this.lastAnswer
        } else {
          //add new answer
          this.allAnswers.push(this.lastAnswer)
        }

        this.lastAnswer = {}
      }

      await this.checkInvalidAnswers()

      this.questionIndex++
      this.model++


    },
    checkInvalidAnswers() {
      this.invalidAnswers = []
      //watch to be activated
      this.hasSubmittedSurvey = true
      for (let i = 0; i < this.allAnswers.length; i++) {
        if (this.allAnswers[i].type == 1 || this.allAnswers[i].type == 2 || this.allAnswers[i].type == 3) {
          if (this.allAnswers[i].selections.length == 0) {
            this.invalidAnswers.push(this.allAnswers[i].id)
          }

        } else if (this.allAnswers[i].type == 4) {

          if (this.allAnswers[i].answer.trim() == '') {
            this.invalidAnswers.push(this.allAnswers[i].id)
          }

        } else if (this.allAnswers[i].type == 5) {
          if (this.allAnswers[i].answer.trim() == '' || this.allAnswers[i].attachment == null) {
            //if(this.allAnswers[i].answer.trim() == ''){
            this.invalidAnswers.push(this.allAnswers[i].id)
          }

        } else if (this.allAnswers[i].type == 6 || this.allAnswers[i].type == 7) {
          if (this.allAnswers[i].rating == 0) {
            this.invalidAnswers.push(this.allAnswers[i].id)
          }

        } else {
          if (this.allAnswers[i].rating == 0 || this.allAnswers[i].answer.trim() == '') {
            this.invalidAnswers.push(this.allAnswers[i].id)
          }

        }
      }
    },
    async startSurvey(name) {
      try {
        let data = {
          data: {
            type: "survey-attempts",
            attributes: {
              submitted_by: name
            },
            relationships: {
              survey: {
                data: {
                  type: "surveys",
                  id: this.surveyId
                }
              }
            }
          }
        };
        const response = await startAttemptInSurvey(data)
        if (response.status == 201) {
          this.model = 1
          this.name = name
          this.started = true
          this.showActivityNavigation = false
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 403) {
            this.$router.push({ name: 'PageAccessDenied' })
          } else if (e.response.status == 404) {
            this.$router.push({ name: 'PageNotFound' })
          } else {
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          }
        }
      }
    },
    async submitSurvey() {

      await this.checkInvalidAnswers()

      if (this.invalidAnswers.length > 0) {
        //
      } else {
        try {
          if (this.name) { // Check if this.name is defined and truthy
            let data = {
              data: {
                type: "surveys",
                attributes: {
                  "submitted_by": this.name,
                  "questions": this.allAnswers
                },
              }
            };
            const response = await submitSurvey(this.surveyId, data);
            if (response) {
              if (response.status == 200) {
                this.preventRedirect = false
                this.confirmationMessage = true;
                eventBus.$emit('checkUpdates', true, this.checkboxCertificate)
                this.showActivityNavigation = true
              }
            }
          } else {
            let data = {
              data: {
                type: "surveys",
                attributes: {
                  "submitted_by": '',
                  "questions": this.allAnswers
                },
              }
            };
            const response = await submitSurvey(this.surveyId, data);
            if (response) {
              if (response.status == 200) {
                this.preventRedirect = false
                this.confirmationMessage = true;
                eventBus.$emit('checkUpdates', true, this.checkboxCertificate)
                this.showActivityNavigation = true
              }
            }
          }
        } catch (e) {
          if (e.response) {
            if (e.response.status == 422) {
              this.alertValue = true
              this.alertType = 'error'
              this.alertMsg = i18n.t('serverError')
            } else if (e.response.status == 403) {
              // this.$router.push({name: 'PageAccessDenied'})
            } else {
              this.alertValue = true
              this.alertType = 'error'
              this.alertMsg = i18n.t('serverError')
            }
          }
        }

      }
    },
    redirectToUnasweredQuestion() {
      this.model = this.allQuestions.findIndex(item => item.id == this.invalidAnswers[0])
    }

  },
}
</script>
<style lang="scss" scoped> .v-window {

   &-x-transition,
   &-x-reverse-transition,
   &-y-transition,
   &-y-reverse-transition {

     &-enter-active,
     &-leave-active {
       transition: 1s cubic-bezier(0.25, 0.8, 0.5, 1) !important;
     }
   }
 }
</style>